const KEY = 'deyran_token';

const isExpired = (token) => {
  try {
    const { exp } = JSON.parse(atob(token.split('.')[1]));
    return !exp || exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};

export const getToken = () => {
  const token = localStorage.getItem(KEY);
  if (!token) return null;
  if (isExpired(token)) {
    localStorage.removeItem(KEY);
    return null;
  }
  return token;
};

export const setToken = (token) => localStorage.setItem(KEY, token);

export const clearToken = () => localStorage.removeItem(KEY);
